import { RootState } from "../rootReducer"

export const selectGetAgentsState = (state: RootState) => state.agents.agents
export const selectAgents = (state: RootState) => state.agents.agents.data
export const selectAgentDeclarations = (state: RootState) => state.agents.agentDeclarations
export const selectCreateAgentState = (state: RootState) => state.agents.createAgent
export const selectUpdateAgentState = (state: RootState) => state.agents.updateAgent
